import React from 'react';
import { useNavigate } from 'react-router-dom';
import crossBack from '../../themed/images/close-btn.svg';
function CrossBack({ className, url }) {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => {
        navigate(url ? url : '/');
      }}
      className={`cross_back-btn${className ? ` ${className}` : ''}`}
    >
      <img src={crossBack} alt="boton retroceser" />
    </div>
  );
}
export default CrossBack;
